import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import { t } from 'i18next';
import moment from 'moment';

const LoadVisitModal = ({
	show,
	handleClose,
	handleSelectVisit,
	visits,
}) => {
	return (

		<Modal
			show={show}
			onHide={handleClose}
			backdrop="static"
			centered
			size="lg"
		>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('GENERAL.LOAD')} Previous Visits{' '}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{visits.length > 0 ? (
					<Table striped bordered hover>
						<thead>
							<tr>
								<th>ID</th>
								<th>Date</th>
							</tr>
						</thead>
						<tbody>
							{visits.map((visit) => (
								<tr key={visit.id} onClick={() => handleSelectVisit(visit)} className="cursor-pointer">
									<td>{visit.id}</td>
									<td>{moment(visit.created_at).format('DD-MM-YYYY HH:mm')}</td>
								</tr>
							))}
						</tbody>
					</Table>
				) : (
					<div className='text-center m-3'>
						<h5>{t('VISIT.NO_VISITS')}</h5>
					</div>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default LoadVisitModal;
